import { LotteriesContext } from 'contexts/lotteries';
import { ModalsContext, ModalType } from 'contexts/modal';
import { useContext, useEffect, useRef } from 'react';
import { useIsGamePage } from './useIsGamePage';

export const useLotteryWinModal = () => {
  const { winQueue, cmsLotteriesPending } = useContext(LotteriesContext);
  const { modals, handleModal } = useContext(ModalsContext);
  const { isGamePage } = useIsGamePage();

  const nextLotteryId = winQueue[0];
  const hasOpenModal = modals.length > 0;
  // the closed popup marks itself seen on unmount, after this effect already ran
  const lastShownId = useRef<number | null>(null);

  useEffect(() => {
    // an empty queue, e.g. after a logout: the next player may win the same lottery
    if (nextLotteryId === undefined) {
      lastShownId.current = null;
      return;
    }

    // the popup shows the CMS art and names, so it waits for them; a game in play waits too
    if (
      nextLotteryId === lastShownId.current ||
      hasOpenModal ||
      cmsLotteriesPending ||
      isGamePage
    ) {
      return;
    }

    lastShownId.current = nextLotteryId;

    // no URL parameter: the popup needs the lottery id to restore
    handleModal(ModalType.LotteryWin, {
      stayInSameWindow: true,
      props: { lotteryId: nextLotteryId },
    })();
  }, [
    nextLotteryId,
    hasOpenModal,
    cmsLotteriesPending,
    isGamePage,
    handleModal,
  ]);
};
